import styled from "@emotion/styled";
import { Page } from "@ui/components/common/page";
import { row, stack } from "@ui/style";
import { colors } from "@ui/style/colors";
import React from "react";

export const LegalContentPage: React.FC<{
	logo?: boolean;
	title?: string;
	subtitle: string;
	description?: string;
	children?: React.ReactNode;
}> = ({ title, description, subtitle, children }) => (
	<StyledPage>
		<Content>
			<Wrapper>
				{title && <Title>{title}</Title>}
				<Subtitle>{subtitle}</Subtitle>
				{description && <Description>{description}</Description>}
				{children}
			</Wrapper>
		</Content>
	</StyledPage>
);

const Content = styled.div`
	${row(undefined, "center", "center")};
`;

const Wrapper = styled.div`
	${stack("M", "flexstart", "center")};
`;

const Title = styled.h1`
	color: ${colors.primary};
	text-align: center;
`;

const Subtitle = styled.h3`
	text-align: center;
`;

const Description = styled.div`
	text-align: center;
`;

const StyledPage = styled(Page)`
	justify-content: center;
`;
